export const usdtAddress = '0x55d398326f99059ff775485246999027b3197955';
export const zeroAddress = '0x0000000000000000000000000000000000000000';
export const refTopAddr = '0x5E09a32A7F59eA7A067Dde41D00a2d9857fc6B40';
export const refTopUser = 'Abcd';

export const coreVaultAddress = '0xc429964b8F04965bAf1d0A2859F1B8D080AAC190';
export const gameAddress = '0x4724D98Ac38c19498fbd3261Ce5928Fc3f22B1c1';
export const game2Address = '0xeB483c4c2182949F92Bd740812f230db151c91b2';

/** On-chain game contract for a game id (Apex2 uses the second deployment). */
export function getGameContractAddress(gameId) {
  return gameId === 'apex2' ? game2Address : gameAddress;
}

/** Unique game contract addresses used for log aggregation. */
export const gameContractAddresses = [gameAddress]; // game2Address